module.exports = __webpack_public_path__ + "static/bsas015.thumb-fd19199ad609d24a515e01769baf960e.jpg";